import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './VerticalScrollable.css';

interface IVerticalScrollableProps {
  sliderRef?: React.MutableRefObject<HTMLUListElement | null>;
  className?: string;
  dataName?: string;
  withScrollPadding?: boolean;
}

export const VerticalScrollable: React.FC<React.PropsWithChildren<IVerticalScrollableProps>> = ({
  sliderRef,
  children,
  className,
  dataName,
  withScrollPadding = true,
}) => {
  return (
    <ul
      ref={sliderRef}
      className={clsx(styles['container'], withScrollPadding && styles['padded'], className)}
      data-name={dataName}
    >
      {React.Children.map(children, (child, i) => child && <li key={i}>{child}</li>)}
    </ul>
  );
};
